import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-z-add-social-links',
  templateUrl: './z-add-social-links.component.html',
  styleUrls: ['./z-add-social-links.component.scss']
})
export class ZAddSocialLinksComponent implements OnInit {
formData: any = {
  link: '',
  platform: '',

};
platforms: string[] = [
  'facebook',
  'instagram',
  'twitter',
  'tiktok',
  'linkedin',
  'youtube',
  'snapchat',
  'whatsapp',
  'telegram'
];

   public arrCoupons: any[] = [];

    public currentLang : string
errors: any = {}; // store validation errors

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')


                  this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  this.formData.image = file.name; // send only file name ✔
}


    cancel(): void {
      this.router.navigate(['/z-social-links']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

  const payload = {
    link: this.formData.link,
    platform: this.formData.platform,

  };

  this.apisService.addSocialLinks(payload).subscribe({
   next: () => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تمت الإضافة بنجاح'
      : 'Added successfully'
  );

  this.router.navigate(['/z-social-links']);
},

error: () => {
  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ أثناء الإضافة'
      : 'Error adding'
  );
}

  });
}


}